import { createFileRoute } from "@tanstack/react-router";

import { PraxaProductionSurface } from "../components/praxa/PraxaProductionSurface";

export const Route = createFileRoute("/w/$workspaceId/production/")({
  component: PraxaProductionRoute,
});

function PraxaProductionRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaProductionSurface workspaceId={workspaceId} />;
}
